import React, { useState, useEffect } from "react";
import PageTitle from "@/Components/PageTop/PageTitle";
import { getQueryString, randomId } from "@/config/func";
import {
  message,
  Popconfirm,
  Result,
  Space,
  Spin,
  Button,
  Divider,
  Alert,
} from "antd";
import dayjs from "dayjs";
import { useNavigate, useParams } from "react-router-dom";
import userInfo from "@/Components/user";
import {
  getProject,
  flows,
  delFlow,
  createFlow,
  uploadFile,
  updateFlow,
  projectsAll,
} from "@/services/common";
import { RollbackOutlined } from "@ant-design/icons";
import CreateProject from "@/Components/CreateModal/CreateProjectModal";
import UpdataFlowInfo from "@/Components/CreateModal/UpdataFlowInfo";
import CreateFlowInfo from "@/Components/CreateModal/CreateFlowInfo";
import emptyImg from "@/assets/icons/empty.svg";
import PageTop from "../PageTop";
import { AppProvider, useAppContext } from "@/AppContext";
import Left from "./Left";
import ProjectMenu from "./ProjectMenu";

const Component = (props: any) => {
  const [curSource, setCurSource] = useState<any>(null);
  const [createModalStatus, setCreateModalStatus] = useState(false);
  const [updateFlowModalStatus, setUpdateFlowModalStatus] = useState(false);
  const [createFlowModalStatus, setCreateFlowModalStatus] = useState(false);
  const [loading, setloading] = useState(false);
  const [curFlowInfo, setCurFlowInfo] = useState<any>(null);
  const [projectMenuList, setProjectMenuList] = useState<any>(null);
  const navigate = useNavigate();
  const { state, actions } = useAppContext();
  const params = useParams();
  const loadData = () => {
    setloading(true);
    const pid = getQueryString("k");
    getProject(pid, userInfo.access_token).then((r) => {
      const flowList = getFlows(pid);
      flowList.then((f) => {
        setCurSource({
          ...r.data,
          flows: f.data.data,
        });
        setloading(false);
      });
    });
  };
  const projectsList = () => {
    projectsAll(
      {
        owner_id: 1,
      },
      userInfo.access_token
    ).then((r) => {
      setProjectMenuList(r.data.data);
    });
  };
  useEffect(() => {
    projectsList();
  }, []);
  //读取项目流程列表
  const getFlows = async (pid: any) => {
    return flows(
      pid,
      {
        page: 1,
        perPage: 1000,
      },
      userInfo.access_token
    );
  };

  useEffect(() => {
    loadData();
  }, [getQueryString("k")]);

  const del_confirm = async (project_id: any, flowId: number) => {
    try {
      await delFlow(project_id, flowId, userInfo.access_token).then((r) => {
        if (r.status === 200) {
          message.success("流程已删除!");
          loadData();
        } else {
          message.error("流程删除失败!");
        }
      });
    } catch (error) {
      const str = error?.response?.data?.detail || "删除失败";
      message.error(str);
    }
  };
  async function downloadAndRename(curFlow) {
    try {
      // 下载原始JSON文件
      const response = await fetch(curFlow.flow_data_url);
      const jsonData = await response.json();

      // 生成新文件名（示例：保留项目ID和流程ID）
      const newFileName = `flow_${curFlow.project_id}_${curFlow.id
        }_${randomId()}_modified.json`;

      // 2. 将JSON转为Blob对象
      const blob = new Blob([JSON.stringify(jsonData)], {
        type: "application/json",
      });

      // 3. 创建FormData并上传
      const formData = new FormData();
      formData.append("file", blob, newFileName);

      const uploadResponse = await uploadFile(formData, userInfo.access_token);
      // const s = await res.json();

      const result = await uploadResponse.json();
      console.log(JSON.stringify(response));
      console.log("result.file_url:", result.fileUrl);
      return result.fileUrl; // 返回新文件地址
    } catch (error) {
      console.error("处理失败:", error);
      throw error;
    }
  }
  const handleCopy = (item) => {
    console.log("item:", item);
    setCurFlowInfo(item);
    downloadAndRename(item).then((newUrl) => {
      const subData = {
        name: "未命名的流程",
        description: item.description,
        thumbnail_url: item.thumbnail_url,
        flow_data_url: newUrl,
      };
      createFlow(curSource.id, subData, userInfo.access_token).then((r) => {
        if (r.status === 200) {
          // message.success("流程复制成功！");
          updateFlow(
            r.data.project_id,
            r.data.id,
            subData,
            userInfo.access_token
          ).then((r) => {
            if (r.status === 200) {
              message.success("流程复制成功！");
              loadData();
              navigate(`/project/${curSource.id}/flow/${r.data.id}/setting`);
            } else {
              message.error("流程复制失败！");
            }
          });
          loadData();
        } else {
          message.error("流程复制失败！");
        }
      });
    });
  };
  // console.log('curSource', curSource);

  return (
    <>
      <PageTop mainContent={<div></div>} />
      <div className="flowMain">
        {/* <div className="flow-left">
          {projectMenuList ? (
            <ProjectMenu projects={projectMenuList} />
          ) : (
            <div style={{ height: "100%" }}>
              <Spin tip="Loading..." size="large" style={{ top: "18vh" }}>
                <div style={{ padding: '50px' }} />
              </Spin>
            </div>
          )}

        </div> */}
        <div className="flow-right">
          <div>
            <PageTitle
              title={
                curSource ? (
                  <Space>
                    {curSource.name}
                    <div style={{ marginLeft: "1rem" }}>
                      <Space>
                        <Button
                          size="small"
                          style={{ border: "none" }}
                          onClick={() => setCreateModalStatus(true)}
                        >
                          <div className="icon edit off"></div>
                        </Button>
                      </Space>
                    </div>
                  </Space>
                ) : null
              }
              extra={
                <Space>
                  {/* <div className="button_new"
                style={{ marginLeft: '3rem' }}
                onClick={() => setCreateFlowModalStatus(true)}>
                + 新建流程
              </div> */}
                  <div
                    className="button_cancle_new"
                    onClick={() => navigate("/project/home/list")}
                  >
                    <RollbackOutlined style={{ color: "#aaa" }} />
                  </div>
                </Space>
              }
            />
          </div>
          <div className="indexShow">
            {!loading ? (
              <>
                <div className="indexShowMain">
                  <div className="page_Content">
                    <div className="content_top">
                      <div className="p_img">
                        <div className="showSImg">
                          <div className="showSImg_inner">
                            <img src={curSource?.thumbnail_url} alt="" />
                          </div>
                        </div>
                      </div>
                      <div className="p_descs">
                        <ul className="p_params">
                          <li>
                            <div>
                              <p>流程总数</p>
                              <p style={{ color: "orange" }}>
                                {curSource ? curSource.flow_count : 0}
                              </p>
                            </div>
                          </li>
                          <li>
                            <div>
                              <p>任务总数</p>
                              <p style={{ color: "#1b6ae7" }}>
                                {curSource ? curSource.job_count : 0}
                              </p>
                            </div>
                          </li>
                          <li>
                            <div>
                              <p>创建日期</p>
                              <p>
                                {curSource
                                  ? dayjs(curSource.created_at).format(
                                    "YYYY-MM-DD"
                                  )
                                  : ""}
                              </p>
                            </div>
                          </li>
                          <li>
                            <div>
                              <p>创建人</p>
                              <p>{userInfo.username}</p>
                            </div>
                          </li>
                        </ul>
                        <div className="p_descs_detail mt2">
                          <div className="p_descs_title t2">项目概述：</div>
                          <div className="p_descs_detail_content">
                            {curSource ? curSource.description : ""}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="content_bottom mt2">
                      <div className="t3 bule">
                        已创建的流程：
                        <div
                          className="button_new"
                          style={{
                            marginLeft: "3rem",
                            display: "inline-block",
                          }}
                          onClick={() => setCreateFlowModalStatus(true)}
                        >
                          + 新建流程
                        </div>
                      </div>
                      <div className="scroll_flow">
                        {curSource ? (
                          <ul className="flowImgList mt1">
                            {curSource.flows.length > 0 ? (
                              curSource.flows.map((item: any, index: any) => {
                                return (
                                  <li key={index}>
                                    <div
                                      className="imgInner showSImgborder"
                                      onClick={() => {
                                        let path = `/project/${curSource.id}/flow/${item.id}`;
                                        if (item.job_count > 0) {
                                          path += '/task';
                                        } else if (item.global_data && Object.keys(item.global_data).length > 0) {
                                          path += '/design1';
                                        } else {
                                          path += '/setting';
                                        }
                                        navigate(path);
                                      }}
                                    // onClick={() =>
                                    //   navigate(
                                    //     `/project/${curSource.id}/flow/${item.id}`
                                    //   )
                                    // }
                                    >
                                      <div className="showSImg">
                                        <div className="showSImg_inner">
                                          {item.thumbnail_url ? (
                                            <img
                                              src={item.thumbnail_url}
                                              alt=""
                                            />
                                          ) : (
                                            <div className="nopic">
                                              <div>
                                                <img
                                                  src={emptyImg}
                                                  alt=""
                                                  style={{
                                                    height: "auto",
                                                    width: "auto",
                                                  }}
                                                />
                                                <div className="notext">
                                                  暂无封面
                                                </div>
                                              </div>
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                    <div className="showFname">
                                      <div className="sp_left">
                                        <div
                                          className="sp_name"
                                        // onClick={() =>
                                        //   navigate(
                                        //     `/project/flow?k=${curSource.id}&f=${item.id}`
                                        //   )
                                        // }
                                        >
                                          {item.name}
                                        </div>
                                        <div className="sp_date">
                                          {dayjs(item.created_at).format(
                                            "YYYY-MM-DD"
                                          )}
                                        </div>
                                      </div>
                                      <div className="sp_right">
                                        <div
                                          className="sp_icon sp_icon_copy"
                                          title="复制"
                                          onClick={() => handleCopy(item)}
                                        />
                                        <div
                                          className="sp_icon sp_icon_edit"
                                          title="修改"
                                          onClick={() => {
                                            setCurFlowInfo(item);
                                            setUpdateFlowModalStatus(true);
                                          }}
                                        />
                                        <Popconfirm
                                          title="确定删除该流程吗？"
                                          description="删除后不可恢复！"
                                          onConfirm={async () => {
                                            const res: any = await del_confirm(
                                              item.project_id,
                                              item.id
                                            );
                                          }}
                                          // onCancel={cancel}
                                          okText="是"
                                          cancelText="否"
                                        >
                                          <div
                                            className="sp_icon sp_icon_delete"
                                            title="删除"
                                          />
                                        </Popconfirm>
                                      </div>
                                    </div>
                                  </li>
                                );
                              })
                            ) : (
                              <div
                                className="noResults mt2"
                                style={{
                                  width: "100%",
                                  height: "calc(100% - 3rem)",
                                }}
                              >
                                <Result
                                  status="info"
                                  title={
                                    <div className="t2 w">
                                      暂时没有创建的流程，请添加流程！
                                    </div>
                                  }
                                ></Result>
                              </div>
                            )}
                          </ul>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <div className="loadingArea">
                <Spin />
              </div>
            )}

            {curSource ? (
              <>
                <CreateProject
                  status={createModalStatus}
                  setStatus={setCreateModalStatus}
                  userInfo={userInfo}
                  loadData={loadData}
                  type="edit"
                  source={curSource}
                />
                <CreateFlowInfo
                  status={createFlowModalStatus}
                  setStatus={setCreateFlowModalStatus}
                  userInfo={userInfo}
                  loadData={loadData}
                  source={curSource}
                />
              </>
            ) : (
              ""
            )}
            {curFlowInfo ? (
              <UpdataFlowInfo
                status={updateFlowModalStatus}
                setStatus={setUpdateFlowModalStatus}
                userInfo={userInfo}
                loadData={loadData}
                source={curFlowInfo}
              />
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Component;
